module.exports = __webpack_public_path__ + "static/media/job_bedroom.bfe50f85.svg";